import React from 'react';
import BaseComponent from 'base-component';
import SoftKeyStore from 'soft-key-store';
import '../assets/index.scss';

let id = 0;

export default class Dialog extends BaseComponent {
  name = 'Dialog';

  static defaultProps = {
    header: '',
    content: '',
    type: 'confirm',
    inputType: 'text',
    inputMode: '',
    ok: '',
    cancel: '',
    onOk: null,
    onBack: null,
    onCancel: null,
    onHide: null,
    onBlur: null,
    translated: false,
    buttons: [],
    showCheckbox: false,
    checkboxCheckedByDefault: false,
    checkboxMessage: '',
    placeholder: '',
    initialValue: '',
    additionalContent: null,
    maxLength: 100,
    progressValue: '',
    progressMax: '',
    noClose: false,
    noFocus: false,
    hideCancel: false,
    hideOkWhenNoInputValue: false
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.type === 'prompt') {
      this.input.value = this.props.initialValue || '';
    }
  }

  componentDidMount() {
    this.content = this.element.querySelector('.content');

    if (this.props.type === 'prompt') {
      this.input.setAttribute('x-inputmode', this.props.inputMode);
    }

    this.updateSoftKeys();
  }

  scrollContent(direction) {
    if (!this.content) {
      return;
    }
    var maxOffset = this.content.scrollHeight - this.content.clientHeight;
    if((this.content.scrollTop == 0 && direction < 0)
      ||(this.content.scrollTop == maxOffset && direction > 0)){
      return false;
    } else {
      var scorlloffset ;
      var distance = this.content.clientHeight - 41;
      if (direction > 0) {
        scorlloffset= this.content.scrollTop +  distance;
      } else if (direction < 0){
        scorlloffset= this.content.scrollTop -  distance;
      }

      if (scorlloffset < 0) {
        scorlloffset = 0;
      } else if (scorlloffset > maxOffset){
        scorlloffset = maxOffset;
      }
      this.content.scrollTo(0, scorlloffset);
      return true;
    }
  }

  updateSoftKeys() {
    if (this.props.type !== 'custom') {
      if (this.props.type === 'alert') {
        SoftKeyStore.register({
          left: '',
          center: this.props.ok || 'ok',
          right: ''
        }, this.element);
      } else if ('progress' === this.props.type) {
        SoftKeyStore.register({
          left: this.props.hideCancel ? '' : (this.props.cancel || 'cancel'),
          center: '',
          right: ''
        }, this.element);
      } else {
        let config = {
          left: this.props.cancel || 'cancel',
          center: '',
          right: this.props.ok || 'ok'
        };
        if (this.props.hideOkWhenNoInputValue && !this.input.value) {
          config.right = '';
        }
        SoftKeyStore.register(config, this.element);
      }
    } else {
      var buttons = this.props.buttons;
      if (buttons.length === 3) {
        if (this.props.type !== 'alert') {
          SoftKeyStore.register({
            left: buttons[0].message,
            center: buttons[1].message,
            right: buttons[2].message
          }, this.element);
        } else {
          SoftKeyStore.register({
            left: '',
            center: 'ok',
            right: ''
          }, this.element);
        }
      } else if (buttons.length === 2) {
        SoftKeyStore.register({
          left: buttons[0].message,
          center: '',
          right: buttons[1].message
        }, this.element);
        if (this.checkbox) {
          SoftKeyStore.register({
            center: this.checkbox.dataset.icon === 'check-on' ? 'off' : 'on'
          }, this.checkboxContainer);
        }
      } else if (buttons.length === 1) {
        SoftKeyStore.register({
          left: '',
          center: buttons[0].message,
          right: ''
        }, this.element);
      }
    }
  }

  focus() {
    this.focusIfPossible();
    this.updateSoftKeys();
  }

  focusIfPossible() {
    if (this.isHidden()) {
      return;
    }
    if (this.props.type === 'custom' && this.checkboxContainer) {
      this.checkboxContainer.focus();
    } else if (this.props.type === 'prompt') {
      this.input.focus();
    } else if (!this.props.noFocus) {
      if (this.content) {
        // For ally
        this.content.focus();
      } else {
        this.element.focus();
      }
    }
  }

  hide() {
    if (this.props.type === 'prompt') {
      this.input.value = this.props.initialValue || '';
    }

    super.hide();

    this.props.onHide && this.props.onHide();
  }

  getInstanceID() {
    if (!this._id) {
      this._id = id;
      id++;
    }
    return this._id;
  }

  componentWillUnmount() {
    SoftKeyStore.unregister(this.element);
  }

  onKeyDown(evt) {
    var key = evt.key;
    switch (key) {
      case 'ArrowDown':
        evt.stopPropagation();
        evt.preventDefault();
        this.scrollContent(1);
        break;
      case 'ArrowUp':
        evt.stopPropagation();
        evt.preventDefault();
        this.scrollContent(-1);
        break;
      case 'Enter':
        evt.stopPropagation();
        evt.preventDefault();
        if (this.props.type === 'custom') {
          if (this.props.buttons.length === 3) {
            let value = {
              selectedButton: 1
            };
            if (this.props.showCheckbox) {
              let icon = this.checkbox.dataset.icon;
              value.checked = icon === 'check-on' ? true : false;
            }
            this.props.onOk && this.props.onOk(value);
            if (!this.props.noClose) {
              this.hide();
            }
          } else {
            if (this.props.showCheckbox &&
                document.activeElement === this.checkboxContainer) {
              var icon = this.checkbox.dataset.icon;
              this.checkbox.dataset.icon =
                icon === 'check-on' ? 'check-off' : 'check-on';
              this.updateSoftKeys();
            }
          }
        } else if (this.props.type === 'alert') {
          this.props.onOk && this.props.onOk();
          if (!this.props.noClose) {
            this.hide();
          }
        }
        break;
      case 'F1':
      case 'SoftLeft':
        evt.stopPropagation();
        evt.preventDefault();
        if (this.props.type === 'custom') {
          let value = {
            selectedButton: 0
          };
          if (this.props.showCheckbox) {
            value.checked = this.checkbox.dataset.icon === 'check-on' ? true : false;
          }
          this.props.onOk && this.props.onOk(value);
        } else if (this.props.type !== 'alert') {
          if (this.props.hideCancel) {
            return;
          }
          this.props.onCancel && this.props.onCancel();
        }
        if (this.props.type !== 'alert' && !this.props.noClose) {
          this.hide();
        }
        break;
      case 'F2':
      case 'SoftRight':
        evt.stopPropagation();
        evt.preventDefault();
        if (this.props.hideCancel) {
          return;
        }
        if ('INPUT' === document.activeElement.tagName &&
            !document.activeElement.value &&
            this.props.hideOkWhenNoInputValue) {
          return;
        }
        if (this.props.type === 'custom') {
          let value = {
            selectedButton: this.props.buttons.length === 3 ? 2 : 1
          };
          if (this.props.showCheckbox) {
            value.checked = this.checkbox.checked;
          }
          this.props.onOk && this.props.onOk(value);
        } else if (this.props.type === 'prompt') {
          this.props.onOk && this.props.onOk(this.input.value);
        } else if (this.props.type === 'confirm') {
          this.props.onOk && this.props.onOk();
        }
        if (!this.props.noClose && this.props.type !== 'alert') {
          this.hide();
        }
        break;
      case 'BrowserBack':
      case 'Backspace':
      case 'EndCall':
        if ('INPUT' === document.activeElement.tagName && document.activeElement.value) {
          return;
        }
        evt.stopPropagation();
        evt.preventDefault();
        if (this.props.hideCancel) {
          return;
        }
        this.props.onBack && this.props.onBack();
        if (!this.props.noClose) {
          this.hide();
        }
        break;
    }
  }

  onBlur() {
    this.props.onBlur && this.props.onBlur();
  }

  onPromptInputChange() {
    if (this.props.hideOkWhenNoInputValue) {
      this.updateSoftKeys();
    }
  }

  setRef = (element) => {
    this.element = element;
  }

  render() {
    let header = '';
    if (this.props.header) {
      header = this.props.translated ?
                <div className="header h1" key="no-translated-header"
                     id={'dialog-header-' + this.getInstanceID()}>{this.props.header}</div> :
                <div className="header h1" key="translated-header" data-l10n-id={this.props.header}
                     id={'dialog-header-' + this.getInstanceID()}></div>;
    }
    return <div
              ref={this.setRef}
              className="dialog-container"
              tabIndex="-1"
              onKeyDown={(e) => this.onKeyDown(e)}
              onBlur={()=>{this.onBlur()}}
            >
              <div role="heading" className="dialog" aria-labelledby={'dialog-header-' + this.getInstanceID()}>
                {header}
                {this.props.children ||
                  <div className="content p-ul" ref={(content) => this.content = content} tabIndex="-1">
                    {
                      this.props.translated ? this.props.content : <div data-l10n-id={this.props.content} />
                    }
                    {
                      this.props.type === 'prompt'
                        ? <input ref={(input) => this.input = input} type={this.props.inputType} className="primary" placeholder={this.props.placeholder}
                          defaultValue={this.props.initialValue} maxLength={this.props.maxLength} onChange={(e) => this.onPromptInputChange(e)} />
                        : ''
                    }
                    {
                      (this.props.type === 'custom' && this.props.showCheckbox) ?
                        <div tabIndex="-1" ref={(checkboxContainer) => this.checkboxContainer = checkboxContainer}><i ref={(checkbox) => this.checkbox = checkbox} data-icon={this.props.checkboxCheckedByDefault ? 'check-on' : 'check-off'} /><span>{this.props.checkboxMessage}</span></div> : ''
                    }
                    {
                      'progress' === this.props.type ?
                      <div>
                        <p>{this.props.progressValue}/{this.props.progressMax}</p>
                        <progress value={this.props.progressValue} max={this.props.progressMax} />
                      </div>
                      : ''
                    }
                  </div>
                }
                {
                  this.props.additionalContent &&
                    (this.props.translated ? (
                      <div className="additional-content">
                        {this.props.additionalContent}
                      </div>
                    ) : (
                      <div
                        className="additional-content"
                        data-l10n-id={this.props.additionalContent}
                      />
                    ))
                }
              </div>
           </div>
  }
}
